import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  HttpMethod_GET_getInstance2m1rvu4d8a2j3 as HttpMethod_GET_getInstance,
  HttpMethod_POST_getInstance3c6ouf174z7cx as HttpMethod_POST_getInstance,
  HttpMethod_PATCH_getInstance2444xhczsg6ri as HttpMethod_PATCH_getInstance,
  HttpMethod_DELETE_getInstance1ayy9xx1uf6c9 as HttpMethod_DELETE_getInstance,
} from '../../../../kiteui-library/com/lightningkite/kiteui/fetch.mjs';
import {
  serializer1cdzkc3mnhoc4 as serializer,
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  serializer1x79l67jvwntn as serializer_0,
  get_nullable197rfua9r7fsz as get_nullable,
  serializer1hu9wv9at41ww as serializer_1,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  Companion_getInstance3nuke4pai11e0 as Companion_getInstance,
  Companion_instance1jgtwyaz4kdue as Companion_instance_0,
  Companion_getInstance1zugja4gs8z3u as Companion_getInstance_0,
  Companion_getInstance6uhn60p4e96h as Companion_getInstance_1,
  Companion_instance2323gbvzg2l6b as Companion_instance_1,
  Companion_instance1jr11iungn4qh as Companion_instance_2,
  Companion_getInstance3dtgneissrfcv as Companion_getInstance_2,
  Companion_getInstancem5ekhykter02 as Companion_getInstance_3,
  Companion_instancem42ud6s3tl46 as Companion_instance_3,
  Companion_instance1n8yqmuuwqhm2 as Companion_instance_4,
  Companion_getInstance2m9opt1pp6vj6 as Companion_getInstance_4,
  Companion_getInstance1am9aucrot1gq as Companion_getInstance_5,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  Companion_getInstance2vq5qbtte0dqu as Companion_getInstance_6,
  Companion_getInstanceop74a2t78ktp as Companion_getInstance_7,
  Companion_instance7oj7gdhawh9q as Companion_instance_5,
} from '../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import {
  Companion_getInstance2aea3v0bp26v5 as Companion_getInstance_8,
  Companion_getInstance3qf32mccbb2zd as Companion_getInstance_9,
  Companion_getInstance1ezkh7nuucouo as Companion_getInstance_10,
  Companion_getInstance2siu14nwnk7au as Companion_getInstance_11,
  Companion_getInstance1os6jge06wszv as Companion_getInstance_12,
  Companion_getInstance2irbwqyuggdu2 as Companion_getInstance_13,
} from '../../../../crowpay-shared/com/crowpay/reports/reports.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_getInstance3bisd6gjnm0oz as Companion_getInstance_14,
  ApprovedState3hrsq7yllchx0 as ApprovedState,
  Companion_getInstance307sotgyzbnou as Companion_getInstance_15,
  ChangeRequesthd3ysa2j1i4f as ChangeRequest,
  Companion_getInstance124t3fbljdbyi as Companion_getInstance_16,
  Clientuccelyr89ch8 as Client,
  Companion_getInstance1z8if8hzu5ng5 as Companion_getInstance_17,
  CompletionMessageComment2phagw82v6lch as CompletionMessageComment,
  Companion_getInstance1b21bhtdgqkve as Companion_getInstance_18,
  Contractor1wog4uk4l8u77 as Contractor,
  Companion_getInstance3r9dph6rgwho0 as Companion_getInstance_19,
  ContractorDocument2jcw9hqg98amj as ContractorDocument,
  Companion_getInstance12ven2xbljkm0 as Companion_getInstance_20,
  ContractorNote59o6kpmrrw5h as ContractorNote,
  Companion_getInstancefq4vwlyjorqo as Companion_getInstance_21,
  CrowPayLegalDocumentvhqnf9xycsrg as CrowPayLegalDocument,
  Companion_getInstanceh1cmko92158x as Companion_getInstance_22,
  Dispute39kejofcwuxch as Dispute,
  Companion_instancevwupp4fz0ehs as Companion_instance_6,
  EntityType3jq9a4zvbs0nt as EntityType,
  Companion_getInstancexfdqyjk2ykmw as Companion_getInstance_23,
  FundsRequesthksopls9wk01 as FundsRequest,
  Companion_getInstance12sgbyys5mml7 as Companion_getInstance_24,
  Incident3aojs8cp7629c as Incident,
  Companion_getInstancezuwazqbeik8p as Companion_getInstance_25,
  IncidentMessage1zg9aeg4hgwtu as IncidentMessage,
  Companion_getInstance1up45os1rj3ws as Companion_getInstance_26,
  IncidentMessageComment1adwwkgdgyo0h as IncidentMessageComment,
  Companion_getInstance20myouriyv3u as Companion_getInstance_27,
  ItemChangee3c665suy3yz as ItemChange,
  Companion_getInstance1t0noik4ocb5x as Companion_getInstance_28,
  LegalDocumentAgreement2jq7u4nlw18u as LegalDocumentAgreement,
  Companion_getInstancee6k6ib2dkotb as Companion_getInstance_29,
  License2dabzwgw7jcr2 as License,
  Companion_getInstancex3rnna8pnr6f as Companion_getInstance_30,
  LineItem2rt64afaiyloc as LineItem,
  Companion_getInstance1moufct3sbct9 as Companion_getInstance_31,
  LineItemCompletionMessage2zpi6q6jke1no as LineItemCompletionMessage,
  Companion_getInstance19tkudxb52ql0 as Companion_getInstance_32,
  MailCheckPhysicallytriaqfbh0a67 as MailCheckPhysically,
  Companion_getInstance28gwov6pby7lz as Companion_getInstance_33,
  PayAppItemz8p3l02jgtr9 as PayAppItem,
  Companion_getInstance1h9pz6hxur4uj as Companion_getInstance_34,
  PayApplicationmbkdcq3ut87x as PayApplication,
  Companion_getInstance39he8wfhznx8z as Companion_getInstance_35,
  Payout257apsotr6b9a as Payout,
  Companion_getInstance30idiynnpnbn2 as Companion_getInstance_36,
  PendingItemChange1hwhwykx2kyit as PendingItemChange,
  Companion_getInstance14mfei2uzw3x6 as Companion_getInstance_37,
  PendingLineItem7uj25viy3ie8 as PendingLineItem,
  Companion_getInstance1cdih9ztewhpv as Companion_getInstance_38,
  Companion_getInstance2m617r7l2yg9j as Companion_getInstance_39,
  Companion_instance3cy7oygvo3vp5 as Companion_instance_7,
  Companion_getInstance3g7lwy1meor8x as Companion_getInstance_40,
  Projecto73xqbcrzskm as Project,
  ProjectLedgerItem1yul4cns1huli as ProjectLedgerItem,
  Companion_getInstance1cc7a4v9g7e6l as Companion_getInstance_41,
  ProjectMessage3vmbacgk5u7x3 as ProjectMessage,
  Companion_getInstance3ar1by5trsbn7 as Companion_getInstance_42,
  ProjectSettlementDocumentation1o22wkmr8w8uo as ProjectSettlementDocumentation,
  Companion_getInstance3lubwpz5lc00p as Companion_getInstance_43,
  ProjectTimerh0tihs6u35t6 as ProjectTimer,
  Companion_getInstance2eaghgpohvp5v as Companion_getInstance_44,
  PunchListItem1wbu5dz9rlo4k as PunchListItem,
  Companion_getInstanceha7z78i7nvow as Companion_getInstance_45,
  ScopeView2pjeasrtqdymw as ScopeView,
  Companion_getInstance11rxtahezlto7 as Companion_getInstance_46,
  Specification3fgfbf7ihgj8v as Specification,
  Companion_instance2x6o1nijtl11 as Companion_instance_8,
  Trade15v4llu79udze as Trade,
  Companion_getInstance241hfcdeiz4z5 as Companion_getInstance_47,
  UnlockProjectRequestsb9zq5gbmeux as UnlockProjectRequest,
  Companion_getInstance21u335vgn0mpe as Companion_getInstance_48,
  User8yb1tqk4kykg as User,
} from '../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import {
  Companion_getInstance1i8v5a4alj7fe as Companion_getInstance_49,
  State3dw676r1r3e8w as State,
  ReportType15553nfaf02up as ReportType,
} from '../../../../crowpay-shared/com/crowpay/enums.mjs';
import {
  ClientModelRestEndpointsLive3jcski6s83sw3 as ClientModelRestEndpointsLive,
  ClientModelRestEndpointsPlusUpdatesWebsocketLivefh363mjnrhnn as ClientModelRestEndpointsPlusUpdatesWebsocketLive,
} from '../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/db/ClientModelRestEndpointsLive.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { ClientModelRestEndpointsuzria74ft4w4 as ClientModelRestEndpoints } from '../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/db/ClientModelRestEndpoints.mjs';
import { UUID21wrnrlmk5y1y as UUID } from '../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import {
  HasReadByEndpointsLive3vmvwhttt3ssi as HasReadByEndpointsLive,
  HasReadByWithCreditsEndpointsLive17nkdcbe2canp as HasReadByWithCreditsEndpointsLive,
  HasReadByWithFeedbackEndpointsLive1r08wwk6n4a50 as HasReadByWithFeedbackEndpointsLive,
} from './HasReadByEndpointsLive.mjs';
import { get_DefaultStringArrayFormatk3qh72vmys6l as get_DefaultStringArrayFormat } from '../../../../lightning-server-kiteui-client/com/lightningkite/serialization/urlify.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1i4e9ym37oxmo as serializer_2 } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  StringCompanionObject_instance3alxothmy382k as StringCompanionObject_instance,
  IntCompanionObject_instance3tw56cgyd5vup as IntCompanionObject_instance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { ClientModelRestEndpointsPlusUpdatesWebsocket34r6fusayskwn as ClientModelRestEndpointsPlusUpdatesWebsocket } from '../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/db/deprecated.mjs';
import { Companion_instance3dz2aen8k3fc7 as Companion_instance_9 } from '../../../../lightning-server-shared/com/lightningkite/lightningserver/files/UploadEarlyEndpointModels.mjs';
import {
  Companion_getInstancesldiilhozd0o as Companion_getInstance_50,
  EmailAddress1n0o8cqqfp9qz as EmailAddress,
} from '../../../../lightning-server-shared/com/lightningkite/StringAlts.mjs';
import { PrimitiveClasses_getInstance2v63zn04dtq03 as PrimitiveClasses_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import {
  EmailProofClientEndpointsLive1alityxkq35k4 as EmailProofClientEndpointsLive,
  AuthenticatedOneTimePasswordProofClientEndpointsLivexna614349rpo as AuthenticatedOneTimePasswordProofClientEndpointsLive,
  OneTimePasswordProofClientEndpointsLive38lkvnjxnx70k as OneTimePasswordProofClientEndpointsLive,
  SmsProofClientEndpointsLive2ouvb5xuxwhln as SmsProofClientEndpointsLive,
  UserAuthClientEndpointsLive3v3qnidsvrhq as UserAuthClientEndpointsLive,
  AuthenticatedUserAuthClientEndpointsLive1zz0879mg87jo as AuthenticatedUserAuthClientEndpointsLive,
} from '../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/auth/authInterfaces.mjs';
import {
  Companion_getInstance2a6946bmnnmyk as Companion_getInstance_51,
  Companion_getInstance23zmguv2nlvyd as Companion_getInstance_52,
  EventSubscription13rxmq485x98c as EventSubscription,
  UserEventType3ayinm14vltts as UserEventType,
  Companion_getInstance2tq82jyrde4r as Companion_getInstance_53,
  Notification36ye7lys64zyi as Notification,
} from '../../../../crowpay-shared/com/crowpay/notifications/shared.mjs';
import {
  Companion_getInstance1plstrcui6kcy as Companion_getInstance_54,
  FunnelInstance3u6ziddd47o20 as FunnelInstance,
  Companion_getInstance35jta5xdhkpv2 as Companion_getInstance_55,
  FunnelSummary2xkqtzvrnqmvn as FunnelSummary,
} from '../../../../lightning-server-shared/com/lightningkite/lightningserver/monitoring/models.mjs';
import {
  Companion_getInstance139kwuiq3xn4y as Companion_getInstance_56,
  OtpSecret2919vqlwy0it0 as OtpSecret,
} from '../../../../lightning-server-shared/com/lightningkite/lightningserver/auth/proof/AuthSecrets.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import {
  Companion_getInstancelcczxht3hulj as Companion_getInstance_57,
  Companion_instance9tm2i64vxmrs as Companion_instance_10,
} from '../../../../crowpay-shared/com/crowpay/paymentModels.mjs';
import { Companion_getInstance24vxhhaq3p126 as Companion_getInstance_58 } from '../../../../lightning-server-shared/com/lightningkite/lightningserver/auth/proof/proofModels.mjs';
import { Companion_getInstance2cg5mffg7iayj as Companion_getInstance_59 } from '../../../../lightning-server-shared/com/lightningkite/lightningdb/EntryChange.mjs';
import {
  Companion_getInstance1dz3q9fvss53i as Companion_getInstance_60,
  Sessionjhz9dr2n4d55 as Session,
} from '../../../../lightning-server-shared/com/lightningkite/lightningserver/auth/subject/subjectModels.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_delete__spiywt($this, id, $completion) {
  var tmp = $this.efa_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_0($this, id, $completion) {
  var tmp = $this.gfa_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_1($this, id, $completion) {
  var tmp = $this.kfa_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_2($this, id, $completion) {
  var tmp = $this.mfa_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_3($this, id, $completion) {
  var tmp = $this.qfa_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_4($this, id, $completion) {
  var tmp = $this.sfa_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_5($this, id, $completion) {
  var tmp = $this.vfa_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_6($this, id, $completion) {
  var tmp = $this.zfa_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_7($this, id, $completion) {
  var tmp = $this.bfb_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_8($this, id, $completion) {
  var tmp = $this.efb_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_9($this, id, $completion) {
  var tmp = $this.gfb_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_10($this, id, $completion) {
  var tmp = $this.jfb_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_11($this, id, $completion) {
  var tmp = $this.mfb_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_12($this, id, $completion) {
  var tmp = $this.ofb_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_13($this, id, $completion) {
  var tmp = $this.qfb_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_14($this, id, $completion) {
  var tmp = $this.ufb_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_15($this, id, $completion) {
  var tmp = $this.yfb_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_16($this, id, $completion) {
  var tmp = $this.cfc_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_17($this, id, $completion) {
  var tmp = $this.gfc_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_18($this, id, $completion) {
  var tmp = $this.ifc_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_19($this, id, $completion) {
  var tmp = $this.kfc_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_20($this, id, $completion) {
  var tmp = $this.ofc_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_21($this, id, $completion) {
  var tmp = $this.sfc_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_22($this, id, $completion) {
  var tmp = $this.ufc_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_23($this, id, $completion) {
  var tmp = $this.xfc_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_24($this, id, $completion) {
  var tmp = $this.zfc_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_25($this, id, $completion) {
  var tmp = $this.dfd_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_26($this, id, $completion) {
  var tmp = $this.hfd_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_27($this, id, $completion) {
  var tmp = $this.jfd_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_28($this, id, $completion) {
  var tmp = $this.nfd_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_29($this, id, $completion) {
  var tmp = $this.rfd_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_30($this, id, $completion) {
  var tmp = $this.vfd_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_31($this, id, $completion) {
  var tmp = $this.yfd_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_32($this, id, $completion) {
  var tmp = $this.cfe_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_33($this, id, $completion) {
  var tmp = $this.ffe_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_34($this, id, $completion) {
  var tmp = $this.ife_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_35($this, id, $completion) {
  var tmp = $this.mfe_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_36($this, id, $completion) {
  var tmp = $this.qfe_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_37($this, id, $completion) {
  var tmp = $this.tfe_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_38($this, id, $completion) {
  var tmp = $this.vfe_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_39($this, id, $completion) {
  var tmp = $this.yfe_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_terminateSession__vfalvx($this, $completion) {
  var tmp = $this.cff_1.bej($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_40($this, id, $completion) {
  var tmp = $this.eff_1.hek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Api2AdminReportsLiveClass;
function Api2AdminReportsLive() {
  if (Api2AdminReportsLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.gff_1 = $outer;
      }
      hff($completion) {
        return this.gff_1.iff_1.hei('admin/total-in-escrow', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_instance.k2a(), $completion);
      }
      ffh($completion) {
        return this.gff_1.iff_1.hei('admin/contractor-payable', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_instance.k2a(), $completion);
      }
      gfh($completion) {
        return this.gff_1.iff_1.hei('admin/project-escrow', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_instance.k2a(), $completion);
      }
      hfh(input, $completion) {
        return this.gff_1.iff_1.hei('admin/snapshot/contractor', HttpMethod_POST_getInstance(), Companion_getInstance_8().k2a(), input, ListSerializer(Companion_getInstance_9().k2a()), $completion);
      }
      ifh(input, $completion) {
        return this.gff_1.iff_1.hei('admin/snapshot/homeowner', HttpMethod_POST_getInstance(), Companion_getInstance_10().k2a(), input, ListSerializer(Companion_getInstance_11().k2a()), $completion);
      }
      jfh(input, $completion) {
        return this.gff_1.iff_1.hei('admin/transactions', HttpMethod_POST_getInstance(), Companion_getInstance_12().k2a(), input, ListSerializer(Companion_getInstance_13().k2a()), $completion);
      }
    }
    initMetadataForClass($, 'Api2AdminReportsLive', VOID, VOID, VOID, [0, 1]);
    Api2AdminReportsLiveClass = $;
  }
  return Api2AdminReportsLiveClass;
}
var Api2ApprovedStateLiveClass;
function Api2ApprovedStateLive() {
  if (Api2ApprovedStateLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.ffa_1 = $outer;
        this.efa_1 = new (ClientModelRestEndpointsLive())(this.ffa_1.iff_1, 'approved-states/rest', Companion_getInstance_14().k2a(), Companion_getInstance_49().k2a());
      }
      kfh(input, $completion) {
        return this.efa_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.kfh(input, $completion);
      }
      lfh(input, $completion) {
        return this.efa_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.lfh(input, $completion);
      }
      mfh(input, $completion) {
        return this.efa_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.mfh(input instanceof ApprovedState() ? input : THROW_CCE(), $completion);
      }
      nfh(input, $completion) {
        return this.efa_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.nfh(input, $completion);
      }
      ofh(id, input, $completion) {
        return this.efa_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.ofh(id instanceof State() ? id : THROW_CCE(), input, $completion);
      }
      pfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.pfh(id instanceof State() ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2ApprovedStateLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 0, 1]);
    Api2ApprovedStateLiveClass = $;
  }
  return Api2ApprovedStateLiveClass;
}
var Api2ChangeRequestLiveClass;
function Api2ChangeRequestLive() {
  if (Api2ChangeRequestLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.jfa_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_15().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.gfa_1 = new (ClientModelRestEndpointsLive())(this.jfa_1.iff_1, 'change-requests/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.hfa_1 = new (HasReadByEndpointsLive())(this.jfa_1.iff_1, 'change-requests/rest', Companion_getInstance_15().k2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_15().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.ifa_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.jfa_1.iff_1, 'change-requests/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      qfh(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.jfa_1.iff_1.hei('change-requests/rest/' + tmp$ret$3 + '/publish', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_15().k2a(), $completion);
      }
      rfh(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.jfa_1.iff_1.hei('change-requests/rest/' + tmp$ret$3 + '/un-publish', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_15().k2a(), $completion);
      }
      sfh(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.jfa_1.iff_1.hei('change-requests/rest/' + tmp$ret$3 + '/approved-linked', HttpMethod_POST_getInstance(), serializer_0(StringCompanionObject_instance), input, serializer(Unit_instance), $completion);
      }
      tfh(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.jfa_1.iff_1.hei('change-requests/rest/' + tmp$ret$3 + '/deny-linked', HttpMethod_POST_getInstance(), Companion_getInstance().k2a(), input, serializer(Unit_instance), $completion);
      }
      ufh(input, $completion) {
        return this.gfa_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.ufh(input, $completion);
      }
      vfh(input, $completion) {
        return this.gfa_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.vfh(input, $completion);
      }
      wfh(input, $completion) {
        return this.gfa_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.wfh(input instanceof ChangeRequest() ? input : THROW_CCE(), $completion);
      }
      xfh(input, $completion) {
        return this.gfa_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.xfh(input, $completion);
      }
      yfh(id, input, $completion) {
        return this.gfa_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.yfh(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_0.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      afi(input, $completion) {
        return this.gfa_1.nek(input, $completion);
      }
      vf9(input, $completion) {
        return this.hfa_1.vf9(input, $completion);
      }
      tek() {
        return this.ifa_1.tek();
      }
    }
    initMetadataForClass($, 'Api2ChangeRequestLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2ChangeRequestLiveClass = $;
  }
  return Api2ChangeRequestLiveClass;
}
var Api2ClientLiveClass;
function Api2ClientLive() {
  if (Api2ClientLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.lfa_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_16().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.kfa_1 = new (ClientModelRestEndpointsLive())(this.lfa_1.iff_1, 'clients/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
      }
      bfi(input, $completion) {
        return this.kfa_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.bfi(input, $completion);
      }
      cfi(input, $completion) {
        return this.kfa_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.cfi(input, $completion);
      }
      dfi(input, $completion) {
        return this.kfa_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.dfi(input instanceof Client() ? input : THROW_CCE(), $completion);
      }
      efi(input, $completion) {
        return this.kfa_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.efi(input, $completion);
      }
      ffi(id, input, $completion) {
        return this.kfa_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.ffi(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_1.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2ClientLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 0, 1]);
    Api2ClientLiveClass = $;
  }
  return Api2ClientLiveClass;
}
var Api2CompletionMessageCommentLiveClass;
function Api2CompletionMessageCommentLive() {
  if (Api2CompletionMessageCommentLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.pfa_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_17().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.mfa_1 = new (ClientModelRestEndpointsLive())(this.pfa_1.iff_1, 'completion-message-comments/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.nfa_1 = new (HasReadByEndpointsLive())(this.pfa_1.iff_1, 'completion-message-comments/rest', Companion_getInstance_17().k2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_17().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.ofa_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.pfa_1.iff_1, 'completion-message-comments/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      gfi(input, $completion) {
        return this.mfa_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.gfi(input, $completion);
      }
      hfi(input, $completion) {
        return this.mfa_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.hfi(input, $completion);
      }
      ifi(input, $completion) {
        return this.mfa_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.ifi(input instanceof CompletionMessageComment() ? input : THROW_CCE(), $completion);
      }
      jfi(input, $completion) {
        return this.mfa_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.jfi(input, $completion);
      }
      kfi(id, input, $completion) {
        return this.mfa_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.kfi(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_2.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      vf9(input, $completion) {
        return this.nfa_1.vf9(input, $completion);
      }
      tek() {
        return this.ofa_1.tek();
      }
    }
    initMetadataForClass($, 'Api2CompletionMessageCommentLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2CompletionMessageCommentLiveClass = $;
  }
  return Api2CompletionMessageCommentLiveClass;
}
var Api2ContractorLiveClass;
function Api2ContractorLive() {
  if (Api2ContractorLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.rfa_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_18().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.qfa_1 = new (ClientModelRestEndpointsLive())(this.rfa_1.iff_1, 'contractors/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
      }
      lfi($completion) {
        return this.rfa_1.iff_1.hei('contractors/rest/file-upload-url', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_instance_9.k2a(), $completion);
      }
      mfi(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.rfa_1.iff_1.hei('contractors/rest/' + tmp$ret$3 + '/submit-for-approval', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_18().k2a(), $completion);
      }
      nfi(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.rfa_1.iff_1.hei('contractors/rest/' + tmp$ret$3 + '/financial-setup-token', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, serializer_0(StringCompanionObject_instance), $completion);
      }
      ofi(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.rfa_1.iff_1.hei('contractors/rest/' + tmp$ret$3 + '/setup-direct-payment-info', HttpMethod_POST_getInstance(), Companion_instance_0.k2a(), input, Companion_getInstance_0().k2a(), $completion);
      }
      pfi(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.rfa_1.iff_1.hei('contractors/rest/' + tmp$ret$3 + '/verify-direct-payment-info', HttpMethod_POST_getInstance(), Companion_getInstance_1().k2a(), input, Companion_getInstance_0().k2a(), $completion);
      }
      qfi(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.rfa_1.iff_1.hei('contractors/rest/' + tmp$ret$3 + '/clear-direct-payment-info', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
      }
      rfi(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.rfa_1.iff_1.hei('contractors/rest/' + tmp$ret$3 + '/clear-payment-info', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
      }
      sfi(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.rfa_1.iff_1.hei('contractors/rest/' + tmp$ret$3 + '/payment-info', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, get_nullable(Companion_getInstance_0().k2a()), $completion);
      }
      tfi(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.rfa_1.iff_1.hei('contractors/rest/' + tmp$ret$3 + '/pending-cash-out', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_instance_1.k2a(), $completion);
      }
      ufi(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.rfa_1.iff_1.hei('contractors/rest/' + tmp$ret$3 + '/request-cash-out', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
      }
      vfi(input, $completion) {
        return this.rfa_1.iff_1.hei('contractors/rest/register', HttpMethod_POST_getInstance(), Companion_instance_2.k2a(), input, serializer(Unit_instance), $completion);
      }
      wfi(input, $completion) {
        return this.qfa_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.wfi(input, $completion);
      }
      xfi(input, $completion) {
        return this.qfa_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.xfi(input, $completion);
      }
      yfi(input, $completion) {
        return this.qfa_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.yfi(input instanceof Contractor() ? input : THROW_CCE(), $completion);
      }
      zfi(input, $completion) {
        return this.qfa_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.zfi(input, $completion);
      }
      afj(id, input, $completion) {
        return this.qfa_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.afj(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_3.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2ContractorLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 0, 1]);
    Api2ContractorLiveClass = $;
  }
  return Api2ContractorLiveClass;
}
var Api2ContractorDocumentLiveClass;
function Api2ContractorDocumentLive() {
  if (Api2ContractorDocumentLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.ufa_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_19().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.sfa_1 = new (ClientModelRestEndpointsLive())(this.ufa_1.iff_1, 'contractor-documents/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_19().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.tfa_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.ufa_1.iff_1, 'contractor-documents/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      bfj(input, $completion) {
        return this.sfa_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.bfj(input, $completion);
      }
      cfj(input, $completion) {
        return this.sfa_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.cfj(input, $completion);
      }
      dfj(input, $completion) {
        return this.sfa_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.dfj(input instanceof ContractorDocument() ? input : THROW_CCE(), $completion);
      }
      efj(input, $completion) {
        return this.sfa_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.efj(input, $completion);
      }
      ffj(id, input, $completion) {
        return this.sfa_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.ffj(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_4.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      tek() {
        return this.tfa_1.tek();
      }
    }
    initMetadataForClass($, 'Api2ContractorDocumentLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2ContractorDocumentLiveClass = $;
  }
  return Api2ContractorDocumentLiveClass;
}
var Api2ContractorNoteLiveClass;
function Api2ContractorNoteLive() {
  if (Api2ContractorNoteLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.yfa_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_20().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.vfa_1 = new (ClientModelRestEndpointsLive())(this.yfa_1.iff_1, 'contractor-notes/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.wfa_1 = new (HasReadByEndpointsLive())(this.yfa_1.iff_1, 'contractor-notes/rest', Companion_getInstance_20().k2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_20().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.xfa_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.yfa_1.iff_1, 'contractor-notes/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      gfj(input, $completion) {
        return this.vfa_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.gfj(input, $completion);
      }
      hfj(input, $completion) {
        return this.vfa_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.hfj(input, $completion);
      }
      ifj(input, $completion) {
        return this.vfa_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.ifj(input instanceof ContractorNote() ? input : THROW_CCE(), $completion);
      }
      jfj(input, $completion) {
        return this.vfa_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.jfj(input, $completion);
      }
      kfj(id, input, $completion) {
        return this.vfa_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.kfj(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_5.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      vf9(input, $completion) {
        return this.wfa_1.vf9(input, $completion);
      }
      tek() {
        return this.xfa_1.tek();
      }
    }
    initMetadataForClass($, 'Api2ContractorNoteLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2ContractorNoteLiveClass = $;
  }
  return Api2ContractorNoteLiveClass;
}
var Api2CrowPayLegalDocumentLiveClass;
function Api2CrowPayLegalDocumentLive() {
  if (Api2CrowPayLegalDocumentLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.afb_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_21().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.zfa_1 = new (ClientModelRestEndpointsLive())(this.afb_1.iff_1, 'legal-documents/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
      }
      lfj(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.afb_1.iff_1.hei('legal-documents/rest/' + tmp$ret$3 + '/email', HttpMethod_POST_getInstance(), Companion_getInstance_50().k2a(), new (EmailAddress())(input), serializer(Unit_instance), $completion);
      }
      mfj(input, $completion) {
        return this.zfa_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.mfj(input, $completion);
      }
      nfj(input, $completion) {
        return this.zfa_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.nfj(input, $completion);
      }
      ofj(input, $completion) {
        return this.zfa_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.ofj(input instanceof CrowPayLegalDocument() ? input : THROW_CCE(), $completion);
      }
      pfj(input, $completion) {
        return this.zfa_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.pfj(input, $completion);
      }
      qfj(id, input, $completion) {
        return this.zfa_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.qfj(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_6.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2CrowPayLegalDocumentLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 0, 1]);
    Api2CrowPayLegalDocumentLiveClass = $;
  }
  return Api2CrowPayLegalDocumentLiveClass;
}
var Api2DebugLiveClass;
function Api2DebugLive() {
  if (Api2DebugLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.rfj_1 = $outer;
      }
      sfj(ScheduleName, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, ScheduleName);
        return this.rfj_1.iff_1.hei('debug/schedules/' + tmp$ret$3, HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
      }
      tfj(ReportType_0, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(ReportType()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, ReportType_0);
        return this.rfj_1.iff_1.hei('debug/schedules/payouts/' + tmp$ret$3, HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
      }
    }
    initMetadataForClass($, 'Api2DebugLive', VOID, VOID, VOID, [1]);
    Api2DebugLiveClass = $;
  }
  return Api2DebugLiveClass;
}
var Api2DisputeLiveClass;
function Api2DisputeLive() {
  if (Api2DisputeLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.dfb_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_22().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.bfb_1 = new (ClientModelRestEndpointsLive())(this.dfb_1.iff_1, 'disputes/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_22().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.cfb_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.dfb_1.iff_1, 'disputes/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      ufj(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.dfb_1.iff_1.hei('disputes/rest/' + tmp$ret$3 + '/lock-project', HttpMethod_PATCH_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_22().k2a(), $completion);
      }
      vfj(input, $completion) {
        return this.bfb_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.vfj(input, $completion);
      }
      wfj(input, $completion) {
        return this.bfb_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.wfj(input, $completion);
      }
      xfj(input, $completion) {
        return this.bfb_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.xfj(input instanceof Dispute() ? input : THROW_CCE(), $completion);
      }
      yfj(input, $completion) {
        return this.bfb_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.yfj(input, $completion);
      }
      zfj(id, input, $completion) {
        return this.bfb_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.zfj(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_7.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      tek() {
        return this.cfb_1.tek();
      }
    }
    initMetadataForClass($, 'Api2DisputeLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2DisputeLiveClass = $;
  }
  return Api2DisputeLiveClass;
}
var Api2EmailProofLiveClass;
function Api2EmailProofLive() {
  if (Api2EmailProofLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.bfk_1 = $outer;
        this.afk_1 = new (EmailProofClientEndpointsLive())(this.bfk_1.iff_1, 'auth/proof/email');
      }
      gei(input, $completion) {
        return this.afk_1.gei(input, $completion);
      }
      iei(input, $completion) {
        return this.afk_1.iei(input, $completion);
      }
    }
    initMetadataForClass($, 'Api2EmailProofLive', VOID, VOID, VOID, [1]);
    Api2EmailProofLiveClass = $;
  }
  return Api2EmailProofLiveClass;
}
var Api2EntityTypeLiveClass;
function Api2EntityTypeLive() {
  if (Api2EntityTypeLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.ffb_1 = $outer;
        this.efb_1 = new (ClientModelRestEndpointsLive())(this.ffb_1.iff_1, 'entity-types/rest', Companion_instance_6.k2a(), serializer_0(StringCompanionObject_instance));
      }
      cfk(input, $completion) {
        return this.efb_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.cfk(input, $completion);
      }
      dfk(input, $completion) {
        return this.efb_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.dfk(input, $completion);
      }
      efk(input, $completion) {
        return this.efb_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.efk(input instanceof EntityType() ? input : THROW_CCE(), $completion);
      }
      ffk(input, $completion) {
        return this.efb_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.ffk(input, $completion);
      }
      gfk(id, input, $completion) {
        return this.efb_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.gfk(typeof id === 'string' ? id : THROW_CCE(), input, $completion);
      }
      hfk(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_8.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.hfk(typeof id === 'string' ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2EntityTypeLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 0, 1]);
    Api2EntityTypeLiveClass = $;
  }
  return Api2EntityTypeLiveClass;
}
var Api2EventSubscriptionLiveClass;
function Api2EventSubscriptionLive() {
  if (Api2EventSubscriptionLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.ifb_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_51();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        var tmp_2 = tmp_0.c8k(ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        var tmp_3 = Companion_getInstance_52();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp.gfb_1 = new (ClientModelRestEndpointsLive())(this.ifb_1.iff_1, 'notifications/subscriptions/rest', tmp_2, tmp_3.c8k(ContextualSerializer().zy(tmp_4, null, tmp$ret$5)));
        var tmp_5 = this;
        var tmp_6 = Companion_getInstance_51();
        var tmp_7 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$8 = [];
        var tmp_8 = tmp_6.c8k(ContextualSerializer().zy(tmp_7, null, tmp$ret$8));
        var tmp_9 = Companion_getInstance_52();
        var tmp_10 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$11 = [];
        tmp_5.hfb_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.ifb_1.iff_1, 'notifications/subscriptions/rest', tmp_8, tmp_9.c8k(ContextualSerializer().zy(tmp_10, null, tmp$ret$11)));
      }
      ifk(input, $completion) {
        return this.gfb_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.ifk(input, $completion);
      }
      jfk(input, $completion) {
        return this.gfb_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.jfk(input, $completion);
      }
      kfk(input, $completion) {
        return this.gfb_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.kfk(input instanceof EventSubscription() ? input : THROW_CCE(), $completion);
      }
      lfk(input, $completion) {
        return this.gfb_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.lfk(input, $completion);
      }
      mfk(id, input, $completion) {
        return this.gfb_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.mfk(id instanceof UserEventType() ? id : THROW_CCE(), input, $completion);
      }
      nfk(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_9.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.nfk(id instanceof UserEventType() ? id : THROW_CCE(), $completion);
      }
      tek() {
        return this.hfb_1.tek();
      }
    }
    initMetadataForClass($, 'Api2EventSubscriptionLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2EventSubscriptionLiveClass = $;
  }
  return Api2EventSubscriptionLiveClass;
}
var Api2FundsRequestLiveClass;
function Api2FundsRequestLive() {
  if (Api2FundsRequestLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.lfb_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_23().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.jfb_1 = new (ClientModelRestEndpointsLive())(this.lfb_1.iff_1, 'funds-requests/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_23().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.kfb_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.lfb_1.iff_1, 'funds-requests/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      ofk(input, $completion) {
        return this.jfb_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.ofk(input, $completion);
      }
      pfk(input, $completion) {
        return this.jfb_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.pfk(input, $completion);
      }
      qfk(input, $completion) {
        return this.jfb_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.qfk(input instanceof FundsRequest() ? input : THROW_CCE(), $completion);
      }
      rfk(input, $completion) {
        return this.jfb_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.rfk(input, $completion);
      }
      sfk(id, input, $completion) {
        return this.jfb_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.sfk(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_10.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      tek() {
        return this.kfb_1.tek();
      }
    }
    initMetadataForClass($, 'Api2FundsRequestLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2FundsRequestLiveClass = $;
  }
  return Api2FundsRequestLiveClass;
}
var Api2FunnelInstanceLiveClass;
function Api2FunnelInstanceLive() {
  if (Api2FunnelInstanceLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.nfb_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_54().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.mfb_1 = new (ClientModelRestEndpointsLive())(this.nfb_1.iff_1, 'meta/funnels/instance/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
      }
      tfk(input, $completion) {
        return this.mfb_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.tfk(input, $completion);
      }
      ufk(input, $completion) {
        return this.mfb_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.ufk(input, $completion);
      }
      vfk(input, $completion) {
        return this.mfb_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.vfk(input instanceof FunnelInstance() ? input : THROW_CCE(), $completion);
      }
      wfk(input, $completion) {
        return this.mfb_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.wfk(input, $completion);
      }
      xfk(id, input, $completion) {
        return this.mfb_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.xfk(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_11.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2FunnelInstanceLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 1, 0]);
    Api2FunnelInstanceLiveClass = $;
  }
  return Api2FunnelInstanceLiveClass;
}
var Api2FunnelSummaryLiveClass;
function Api2FunnelSummaryLive() {
  if (Api2FunnelSummaryLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.pfb_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_55().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.ofb_1 = new (ClientModelRestEndpointsLive())(this.pfb_1.iff_1, 'meta/funnels/summary/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
      }
      yfk(input, $completion) {
        return this.ofb_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.yfk(input, $completion);
      }
      zfk(input, $completion) {
        return this.ofb_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.zfk(input, $completion);
      }
      afl(input, $completion) {
        return this.ofb_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.afl(input instanceof FunnelSummary() ? input : THROW_CCE(), $completion);
      }
      bfl(input, $completion) {
        return this.ofb_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.bfl(input, $completion);
      }
      cfl(id, input, $completion) {
        return this.ofb_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.cfl(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_12.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2FunnelSummaryLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 0, 1]);
    Api2FunnelSummaryLiveClass = $;
  }
  return Api2FunnelSummaryLiveClass;
}
var Api2IncidentLiveClass;
function Api2IncidentLive() {
  if (Api2IncidentLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.tfb_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_24().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.qfb_1 = new (ClientModelRestEndpointsLive())(this.tfb_1.iff_1, 'incidents/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.rfb_1 = new (HasReadByEndpointsLive())(this.tfb_1.iff_1, 'incidents/rest', Companion_getInstance_24().k2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_24().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.sfb_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.tfb_1.iff_1, 'incidents/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      lfi($completion) {
        return this.tfb_1.iff_1.hei('incidents/rest/file-upload-url', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_instance_9.k2a(), $completion);
      }
      dfl(input, $completion) {
        return this.qfb_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.dfl(input, $completion);
      }
      efl(input, $completion) {
        return this.qfb_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.efl(input, $completion);
      }
      ffl(input, $completion) {
        return this.qfb_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.ffl(input instanceof Incident() ? input : THROW_CCE(), $completion);
      }
      gfl(input, $completion) {
        return this.qfb_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.gfl(input, $completion);
      }
      hfl(id, input, $completion) {
        return this.qfb_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.hfl(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_13.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      vf9(input, $completion) {
        return this.rfb_1.vf9(input, $completion);
      }
      tek() {
        return this.sfb_1.tek();
      }
    }
    initMetadataForClass($, 'Api2IncidentLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2IncidentLiveClass = $;
  }
  return Api2IncidentLiveClass;
}
var Api2IncidentMessageLiveClass;
function Api2IncidentMessageLive() {
  if (Api2IncidentMessageLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.xfb_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_25().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.ufb_1 = new (ClientModelRestEndpointsLive())(this.xfb_1.iff_1, 'incident-messages/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.vfb_1 = new (HasReadByEndpointsLive())(this.xfb_1.iff_1, 'incident-messages/rest', Companion_getInstance_25().k2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_25().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.wfb_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.xfb_1.iff_1, 'incident-messages/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      ifl(input, $completion) {
        return this.xfb_1.iff_1.hei('incident-messages/rest/send-message', HttpMethod_POST_getInstance(), Companion_getInstance_25().k2a(), input, Companion_getInstance_25().k2a(), $completion);
      }
      jfl(input, $completion) {
        return this.ufb_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.jfl(input, $completion);
      }
      kfl(input, $completion) {
        return this.ufb_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.kfl(input, $completion);
      }
      lfl(input, $completion) {
        return this.ufb_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.lfl(input instanceof IncidentMessage() ? input : THROW_CCE(), $completion);
      }
      mfl(input, $completion) {
        return this.ufb_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.mfl(input, $completion);
      }
      nfl(id, input, $completion) {
        return this.ufb_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.nfl(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_14.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      vf9(input, $completion) {
        return this.vfb_1.vf9(input, $completion);
      }
      tek() {
        return this.wfb_1.tek();
      }
    }
    initMetadataForClass($, 'Api2IncidentMessageLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2IncidentMessageLiveClass = $;
  }
  return Api2IncidentMessageLiveClass;
}
var Api2IncidentMessageCommentLiveClass;
function Api2IncidentMessageCommentLive() {
  if (Api2IncidentMessageCommentLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.bfc_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_26().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.yfb_1 = new (ClientModelRestEndpointsLive())(this.bfc_1.iff_1, 'incident-message-comments/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.zfb_1 = new (HasReadByEndpointsLive())(this.bfc_1.iff_1, 'incident-message-comments/rest', Companion_getInstance_26().k2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_26().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.afc_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.bfc_1.iff_1, 'incident-message-comments/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      ofl(input, $completion) {
        return this.yfb_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.ofl(input, $completion);
      }
      pfl(input, $completion) {
        return this.yfb_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.pfl(input, $completion);
      }
      qfl(input, $completion) {
        return this.yfb_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.qfl(input instanceof IncidentMessageComment() ? input : THROW_CCE(), $completion);
      }
      rfl(input, $completion) {
        return this.yfb_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.rfl(input, $completion);
      }
      sfl(id, input, $completion) {
        return this.yfb_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.sfl(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_15.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      vf9(input, $completion) {
        return this.zfb_1.vf9(input, $completion);
      }
      tek() {
        return this.afc_1.tek();
      }
    }
    initMetadataForClass($, 'Api2IncidentMessageCommentLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2IncidentMessageCommentLiveClass = $;
  }
  return Api2IncidentMessageCommentLiveClass;
}
var Api2ItemChangeLiveClass;
function Api2ItemChangeLive() {
  if (Api2ItemChangeLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.ffc_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_27().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.cfc_1 = new (ClientModelRestEndpointsLive())(this.ffc_1.iff_1, 'item-changes/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.dfc_1 = new (HasReadByEndpointsLive())(this.ffc_1.iff_1, 'item-changes/rest', Companion_getInstance_27().k2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_27().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.efc_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.ffc_1.iff_1, 'item-changes/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      tfl(input, $completion) {
        return this.cfc_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.tfl(input, $completion);
      }
      ufl(input, $completion) {
        return this.cfc_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.ufl(input, $completion);
      }
      vfl(input, $completion) {
        return this.cfc_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.vfl(input instanceof ItemChange() ? input : THROW_CCE(), $completion);
      }
      wfl(input, $completion) {
        return this.cfc_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.wfl(input, $completion);
      }
      xfl(id, input, $completion) {
        return this.cfc_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.xfl(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_16.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      vf9(input, $completion) {
        return this.dfc_1.vf9(input, $completion);
      }
      tek() {
        return this.efc_1.tek();
      }
    }
    initMetadataForClass($, 'Api2ItemChangeLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2ItemChangeLiveClass = $;
  }
  return Api2ItemChangeLiveClass;
}
var Api2LegalDocumentAgreementLiveClass;
function Api2LegalDocumentAgreementLive() {
  if (Api2LegalDocumentAgreementLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.hfc_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_28().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.gfc_1 = new (ClientModelRestEndpointsLive())(this.hfc_1.iff_1, 'legal-document-agreements/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
      }
      yfl(input, $completion) {
        return this.gfc_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.yfl(input, $completion);
      }
      zfl(input, $completion) {
        return this.gfc_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.zfl(input, $completion);
      }
      afm(input, $completion) {
        return this.gfc_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.afm(input instanceof LegalDocumentAgreement() ? input : THROW_CCE(), $completion);
      }
      bfm(input, $completion) {
        return this.gfc_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.bfm(input, $completion);
      }
      cfm(id, input, $completion) {
        return this.gfc_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.cfm(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_17.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2LegalDocumentAgreementLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 0, 1]);
    Api2LegalDocumentAgreementLiveClass = $;
  }
  return Api2LegalDocumentAgreementLiveClass;
}
var Api2LicenseLiveClass;
function Api2LicenseLive() {
  if (Api2LicenseLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.jfc_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_29().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.ifc_1 = new (ClientModelRestEndpointsLive())(this.jfc_1.iff_1, 'licenses/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
      }
      dfm(input, $completion) {
        return this.ifc_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.dfm(input, $completion);
      }
      efm(input, $completion) {
        return this.ifc_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.efm(input, $completion);
      }
      ffm(input, $completion) {
        return this.ifc_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.ffm(input instanceof License() ? input : THROW_CCE(), $completion);
      }
      gfm(input, $completion) {
        return this.ifc_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.gfm(input, $completion);
      }
      hfm(id, input, $completion) {
        return this.ifc_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.hfm(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_18.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2LicenseLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 0, 1]);
    Api2LicenseLiveClass = $;
  }
  return Api2LicenseLiveClass;
}
var Api2LineItemLiveClass;
function Api2LineItemLive() {
  if (Api2LineItemLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.nfc_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_30().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.kfc_1 = new (ClientModelRestEndpointsLive())(this.nfc_1.iff_1, 'line-items/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.lfc_1 = new (HasReadByWithCreditsEndpointsLive())(this.nfc_1.iff_1, 'line-items/rest', Companion_getInstance_30().k2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_30().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.mfc_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.nfc_1.iff_1, 'line-items/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      ifm(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.nfc_1.iff_1.hei('line-items/rest/' + tmp$ret$3 + '/force-refresh-state', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
      }
      lfi($completion) {
        return this.nfc_1.iff_1.hei('line-items/rest/file-upload-url', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_instance_9.k2a(), $completion);
      }
      jfm(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.nfc_1.iff_1.hei('line-items/rest/' + tmp$ret$3 + '/complete', HttpMethod_PATCH_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_30().k2a(), $completion);
      }
      kfm(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.nfc_1.iff_1.hei('line-items/rest/' + tmp$ret$3 + '/add-credit', HttpMethod_PATCH_getInstance(), Companion_getInstance_2().k2a(), input, Companion_getInstance_30().k2a(), $completion);
      }
      lfm(input, $completion) {
        return this.kfc_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.lfm(input, $completion);
      }
      mfm(input, $completion) {
        return this.kfc_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.mfm(input, $completion);
      }
      nfm(input, $completion) {
        return this.kfc_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.nfm(input instanceof LineItem() ? input : THROW_CCE(), $completion);
      }
      ofm(input, $completion) {
        return this.kfc_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.ofm(input, $completion);
      }
      pfm(id, input, $completion) {
        return this.kfc_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.pfm(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_19.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      mek($completion) {
        return this.kfc_1.mek($completion);
      }
      dfa(input, $completion) {
        return this.lfc_1.dfa(input, $completion);
      }
      vf9(input, $completion) {
        return this.lfc_1.vf9(input, $completion);
      }
      tek() {
        return this.mfc_1.tek();
      }
    }
    initMetadataForClass($, 'Api2LineItemLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2LineItemLiveClass = $;
  }
  return Api2LineItemLiveClass;
}
var Api2LineItemCompletionMessageLiveClass;
function Api2LineItemCompletionMessageLive() {
  if (Api2LineItemCompletionMessageLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.rfc_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_31().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.ofc_1 = new (ClientModelRestEndpointsLive())(this.rfc_1.iff_1, 'line-item-completion-messages/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.pfc_1 = new (HasReadByEndpointsLive())(this.rfc_1.iff_1, 'line-item-completion-messages/rest', Companion_getInstance_31().k2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_31().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.qfc_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.rfc_1.iff_1, 'line-item-completion-messages/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      qfm(input, $completion) {
        return this.rfc_1.iff_1.hei('line-item-completion-messages/rest/send-message', HttpMethod_POST_getInstance(), Companion_getInstance_31().k2a(), input, Companion_getInstance_31().k2a(), $completion);
      }
      lfi($completion) {
        return this.rfc_1.iff_1.hei('line-item-completion-messages/rest/file-upload-url', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_instance_9.k2a(), $completion);
      }
      rfm(input, $completion) {
        return this.ofc_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.rfm(input, $completion);
      }
      sfm(input, $completion) {
        return this.ofc_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.sfm(input, $completion);
      }
      tfm(input, $completion) {
        return this.ofc_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.tfm(input instanceof LineItemCompletionMessage() ? input : THROW_CCE(), $completion);
      }
      ufm(input, $completion) {
        return this.ofc_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.ufm(input, $completion);
      }
      vfm(id, input, $completion) {
        return this.ofc_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.vfm(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_20.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      vf9(input, $completion) {
        return this.pfc_1.vf9(input, $completion);
      }
      tek() {
        return this.qfc_1.tek();
      }
    }
    initMetadataForClass($, 'Api2LineItemCompletionMessageLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2LineItemCompletionMessageLiveClass = $;
  }
  return Api2LineItemCompletionMessageLiveClass;
}
var Api2MailCheckPhysicallyLiveClass;
function Api2MailCheckPhysicallyLive() {
  if (Api2MailCheckPhysicallyLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.tfc_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_32().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.sfc_1 = new (ClientModelRestEndpointsLive())(this.tfc_1.iff_1, 'checks/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
      }
      wfm(input, $completion) {
        return this.sfc_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.wfm(input, $completion);
      }
      xfm(input, $completion) {
        return this.sfc_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.xfm(input, $completion);
      }
      yfm(input, $completion) {
        return this.sfc_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.yfm(input instanceof MailCheckPhysically() ? input : THROW_CCE(), $completion);
      }
      zfm(input, $completion) {
        return this.sfc_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.zfm(input, $completion);
      }
      afn(id, input, $completion) {
        return this.sfc_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.afn(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_21.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2MailCheckPhysicallyLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 1, 0]);
    Api2MailCheckPhysicallyLiveClass = $;
  }
  return Api2MailCheckPhysicallyLiveClass;
}
var Api2NotificationLiveClass;
function Api2NotificationLive() {
  if (Api2NotificationLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.wfc_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_53();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        var tmp_2 = tmp_0.g8m(ContextualSerializer().zy(tmp_1, null, tmp$ret$2), Companion_getInstance_3().k2a());
        var tmp_3 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp.ufc_1 = new (ClientModelRestEndpointsLive())(this.wfc_1.iff_1, 'notifications/rest', tmp_2, ContextualSerializer().zy(tmp_3, null, tmp$ret$5));
        var tmp_4 = this;
        var tmp_5 = Companion_getInstance_53();
        var tmp_6 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$8 = [];
        var tmp_7 = tmp_5.g8m(ContextualSerializer().zy(tmp_6, null, tmp$ret$8), Companion_getInstance_3().k2a());
        var tmp_8 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$11 = [];
        tmp_4.vfc_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.wfc_1.iff_1, 'notifications/rest', tmp_7, ContextualSerializer().zy(tmp_8, null, tmp$ret$11));
      }
      bfn(input, $completion) {
        return this.ufc_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.bfn(input, $completion);
      }
      cfn(input, $completion) {
        return this.ufc_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.cfn(input, $completion);
      }
      dfn(input, $completion) {
        return this.ufc_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.dfn(input instanceof Notification() ? input : THROW_CCE(), $completion);
      }
      efn(input, $completion) {
        return this.ufc_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.efn(input, $completion);
      }
      ffn(id, input, $completion) {
        return this.ufc_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.ffn(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_22.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      tek() {
        return this.vfc_1.tek();
      }
    }
    initMetadataForClass($, 'Api2NotificationLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2NotificationLiveClass = $;
  }
  return Api2NotificationLiveClass;
}
var Api2OneTimePasswordProofLiveClass;
function Api2OneTimePasswordProofLive() {
  if (Api2OneTimePasswordProofLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.ifn_1 = $outer;
        this.gfn_1 = new (AuthenticatedOneTimePasswordProofClientEndpointsLive())(this.ifn_1.iff_1, 'auth/proof/otp');
        this.hfn_1 = new (OneTimePasswordProofClientEndpointsLive())(this.ifn_1.iff_1, 'auth/proof/otp');
      }
    }
    initMetadataForClass($, 'Api2OneTimePasswordProofLive', VOID, VOID, VOID, [1]);
    Api2OneTimePasswordProofLiveClass = $;
  }
  return Api2OneTimePasswordProofLiveClass;
}
var Api2OtpSecretLiveClass;
function Api2OtpSecretLive() {
  if (Api2OtpSecretLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.yfc_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_56().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.xfc_1 = new (ClientModelRestEndpointsLive())(this.yfc_1.iff_1, 'auth/proof/otp/secrets', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
      }
      jfn(input, $completion) {
        return this.xfc_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.jfn(input, $completion);
      }
      kfn(input, $completion) {
        return this.xfc_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.kfn(input, $completion);
      }
      lfn(input, $completion) {
        return this.xfc_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.lfn(input instanceof OtpSecret() ? input : THROW_CCE(), $completion);
      }
      mfn(input, $completion) {
        return this.xfc_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.mfn(input, $completion);
      }
      nfn(id, input, $completion) {
        return this.xfc_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.nfn(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_23.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2OtpSecretLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 0, 1]);
    Api2OtpSecretLiveClass = $;
  }
  return Api2OtpSecretLiveClass;
}
var Api2PayAppItemLiveClass;
function Api2PayAppItemLive() {
  if (Api2PayAppItemLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.cfd_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_33().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.zfc_1 = new (ClientModelRestEndpointsLive())(this.cfd_1.iff_1, 'pay-app-items/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.afd_1 = new (HasReadByWithFeedbackEndpointsLive())(this.cfd_1.iff_1, 'pay-app-items/rest', Companion_getInstance_33().k2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_33().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.bfd_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.cfd_1.iff_1, 'pay-app-items/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      ofn(input, $completion) {
        var tmp = HttpMethod_POST_getInstance();
        var tmp_0 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        return this.cfd_1.iff_1.hei('pay-app-items/rest/approve-bulk', tmp, ListSerializer(ContextualSerializer().zy(tmp_0, null, tmp$ret$2)), input, serializer(Unit_instance), $completion);
      }
      pfn(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.cfd_1.iff_1.hei('pay-app-items/rest/' + tmp$ret$3 + '/deny', HttpMethod_POST_getInstance(), serializer_0(StringCompanionObject_instance), input, serializer(Unit_instance), $completion);
      }
      qfn(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.cfd_1.iff_1.hei('pay-app-items/rest/' + tmp$ret$3 + '/void', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_33().k2a(), $completion);
      }
      rfn(input, $completion) {
        return this.zfc_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.rfn(input, $completion);
      }
      sfn(input, $completion) {
        return this.zfc_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.sfn(input, $completion);
      }
      tfn(input, $completion) {
        return this.zfc_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.tfn(input instanceof PayAppItem() ? input : THROW_CCE(), $completion);
      }
      ufn(input, $completion) {
        return this.zfc_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.ufn(input, $completion);
      }
      vfn(id, input, $completion) {
        return this.zfc_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.vfn(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_24.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      zf9(input, $completion) {
        return this.afd_1.zf9(input, $completion);
      }
      vf9(input, $completion) {
        return this.afd_1.vf9(input, $completion);
      }
      tek() {
        return this.bfd_1.tek();
      }
    }
    initMetadataForClass($, 'Api2PayAppItemLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2PayAppItemLiveClass = $;
  }
  return Api2PayAppItemLiveClass;
}
var Api2PayApplicationLiveClass;
function Api2PayApplicationLive() {
  if (Api2PayApplicationLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.gfd_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_34().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.dfd_1 = new (ClientModelRestEndpointsLive())(this.gfd_1.iff_1, 'pay-applications/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.efd_1 = new (HasReadByEndpointsLive())(this.gfd_1.iff_1, 'pay-applications/rest', Companion_getInstance_34().k2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_34().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.ffd_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.gfd_1.iff_1, 'pay-applications/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      lfi($completion) {
        return this.gfd_1.iff_1.hei('pay-applications/rest/file-upload-url', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_instance_9.k2a(), $completion);
      }
      wfn(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.gfd_1.iff_1.hei('pay-applications/rest/' + tmp$ret$3 + '/submit', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
      }
      xfn(input, $completion) {
        return this.dfd_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.xfn(input, $completion);
      }
      yfn(input, $completion) {
        return this.dfd_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.yfn(input, $completion);
      }
      zfn(input, $completion) {
        return this.dfd_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.zfn(input instanceof PayApplication() ? input : THROW_CCE(), $completion);
      }
      afo(input, $completion) {
        return this.dfd_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.afo(input, $completion);
      }
      bfo(id, input, $completion) {
        return this.dfd_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.bfo(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_25.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      vf9(input, $completion) {
        return this.efd_1.vf9(input, $completion);
      }
      tek() {
        return this.ffd_1.tek();
      }
    }
    initMetadataForClass($, 'Api2PayApplicationLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2PayApplicationLiveClass = $;
  }
  return Api2PayApplicationLiveClass;
}
var Api2PayoutLiveClass;
function Api2PayoutLive() {
  if (Api2PayoutLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.ifd_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_35().k2a();
        var tmp_1 = getKClass(Instant());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.hfd_1 = new (ClientModelRestEndpointsLive())(this.ifd_1.iff_1, 'payouts/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
      }
      cfo(input, $completion) {
        return this.hfd_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.cfo(input, $completion);
      }
      dfo(input, $completion) {
        return this.hfd_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.dfo(input, $completion);
      }
      efo(input, $completion) {
        return this.hfd_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.efo(input instanceof Payout() ? input : THROW_CCE(), $completion);
      }
      ffo(input, $completion) {
        return this.hfd_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.ffo(input, $completion);
      }
      gfo(id, input, $completion) {
        return this.hfd_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.gfo(id instanceof Instant() ? id : THROW_CCE(), input, $completion);
      }
      hfo(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_26.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.hfo(id instanceof Instant() ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2PayoutLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 0, 1]);
    Api2PayoutLiveClass = $;
  }
  return Api2PayoutLiveClass;
}
var Api2PendingItemChangeLiveClass;
function Api2PendingItemChangeLive() {
  if (Api2PendingItemChangeLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.mfd_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_36().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.jfd_1 = new (ClientModelRestEndpointsLive())(this.mfd_1.iff_1, 'pending-item-changes/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.kfd_1 = new (HasReadByWithFeedbackEndpointsLive())(this.mfd_1.iff_1, 'pending-item-changes/rest', Companion_getInstance_36().k2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_36().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.lfd_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.mfd_1.iff_1, 'pending-item-changes/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      ifo(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.mfd_1.iff_1.hei('pending-item-changes/rest/' + tmp$ret$3 + '/accept', HttpMethod_POST_getInstance(), serializer_0(StringCompanionObject_instance), input, Companion_getInstance_36().k2a(), $completion);
      }
      jfo(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.mfd_1.iff_1.hei('pending-item-changes/rest/' + tmp$ret$3 + '/deny', HttpMethod_POST_getInstance(), Companion_instance_3.k2a(), input, Companion_getInstance_36().k2a(), $completion);
      }
      kfo(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.mfd_1.iff_1.hei('pending-item-changes/rest/' + tmp$ret$3 + '/withdraw', HttpMethod_PATCH_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_36().k2a(), $completion);
      }
      lfo(input, $completion) {
        return this.jfd_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.lfo(input, $completion);
      }
      mfo(input, $completion) {
        return this.jfd_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.mfo(input, $completion);
      }
      nfo(input, $completion) {
        return this.jfd_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.nfo(input instanceof PendingItemChange() ? input : THROW_CCE(), $completion);
      }
      ofo(input, $completion) {
        return this.jfd_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.ofo(input, $completion);
      }
      pfo(id, input, $completion) {
        return this.jfd_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.pfo(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_27.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      zf9(input, $completion) {
        return this.kfd_1.zf9(input, $completion);
      }
      vf9(input, $completion) {
        return this.kfd_1.vf9(input, $completion);
      }
      tek() {
        return this.lfd_1.tek();
      }
    }
    initMetadataForClass($, 'Api2PendingItemChangeLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2PendingItemChangeLiveClass = $;
  }
  return Api2PendingItemChangeLiveClass;
}
var Api2PendingLineItemLiveClass;
function Api2PendingLineItemLive() {
  if (Api2PendingLineItemLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.qfd_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_37().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.nfd_1 = new (ClientModelRestEndpointsLive())(this.qfd_1.iff_1, 'pending-line-items/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.ofd_1 = new (HasReadByWithFeedbackEndpointsLive())(this.qfd_1.iff_1, 'pending-line-items/rest', Companion_getInstance_37().k2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_37().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.pfd_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.qfd_1.iff_1, 'pending-line-items/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      qfo(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.qfd_1.iff_1.hei('pending-line-items/rest/' + tmp$ret$3 + '/accept', HttpMethod_POST_getInstance(), serializer_0(StringCompanionObject_instance), input, Companion_getInstance_37().k2a(), $completion);
      }
      rfo(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.qfd_1.iff_1.hei('pending-line-items/rest/' + tmp$ret$3 + '/deny', HttpMethod_POST_getInstance(), Companion_instance_3.k2a(), input, Companion_getInstance_37().k2a(), $completion);
      }
      sfo(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.qfd_1.iff_1.hei('pending-line-items/rest/' + tmp$ret$3 + '/withdraw', HttpMethod_PATCH_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_37().k2a(), $completion);
      }
      tfo(input, $completion) {
        return this.nfd_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.tfo(input, $completion);
      }
      ufo(input, $completion) {
        return this.nfd_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.ufo(input, $completion);
      }
      vfo(input, $completion) {
        return this.nfd_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.vfo(input instanceof PendingLineItem() ? input : THROW_CCE(), $completion);
      }
      wfo(input, $completion) {
        return this.nfd_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.wfo(input, $completion);
      }
      xfo(id, input, $completion) {
        return this.nfd_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.xfo(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_28.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      zf9(input, $completion) {
        return this.ofd_1.zf9(input, $completion);
      }
      vf9(input, $completion) {
        return this.ofd_1.vf9(input, $completion);
      }
      tek() {
        return this.pfd_1.tek();
      }
    }
    initMetadataForClass($, 'Api2PendingLineItemLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2PendingLineItemLiveClass = $;
  }
  return Api2PendingLineItemLiveClass;
}
var Api2ProjectLiveClass;
function Api2ProjectLive() {
  if (Api2ProjectLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.ufd_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_38().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.rfd_1 = new (ClientModelRestEndpointsLive())(this.ufd_1.iff_1, 'projects/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.sfd_1 = new (HasReadByWithCreditsEndpointsLive())(this.ufd_1.iff_1, 'projects/rest', Companion_getInstance_38().k2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_38().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.tfd_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.ufd_1.iff_1, 'projects/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      yfo(project, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, project);
        return this.ufd_1.iff_1.hei('projects/rest/' + tmp$ret$3 + '/add-credit', HttpMethod_POST_getInstance(), Companion_getInstance_2().k2a(), input, serializer(Unit_instance), $completion);
      }
      zfo(project, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, project);
        return this.ufd_1.iff_1.hei('projects/rest/' + tmp$ret$3 + '/force-refresh-state', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_38().k2a(), $completion);
      }
      afp(project, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, project);
        return this.ufd_1.iff_1.hei('projects/rest/' + tmp$ret$3 + '/cancel', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_38().k2a(), $completion);
      }
      bfp(project, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, project);
        return this.ufd_1.iff_1.hei('projects/rest/' + tmp$ret$3 + '/abandon', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_38().k2a(), $completion);
      }
      cfp(project, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, project);
        return this.ufd_1.iff_1.hei('projects/rest/' + tmp$ret$3 + '/publish', HttpMethod_PATCH_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_38().k2a(), $completion);
      }
      dfp(project, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, project);
        return this.ufd_1.iff_1.hei('projects/rest/' + tmp$ret$3 + '/unpublish', HttpMethod_PATCH_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_38().k2a(), $completion);
      }
      efp(project, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, project);
        return this.ufd_1.iff_1.hei('projects/rest/' + tmp$ret$3 + '/anonymous-link', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, serializer_0(StringCompanionObject_instance), $completion);
      }
      ffp(project, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, project);
        return this.ufd_1.iff_1.hei('projects/rest/' + tmp$ret$3 + '/anonymous-link', HttpMethod_POST_getInstance(), Companion_instance_4.k2a(), input, serializer(Unit_instance), $completion);
      }
      gfp(project, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, project);
        return this.ufd_1.iff_1.hei('projects/rest/' + tmp$ret$3 + '/anonymous', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_4().k2a(), $completion);
      }
      hfp(project, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, project);
        return this.ufd_1.iff_1.hei('projects/rest/' + tmp$ret$3 + '/notify-viewed', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_38().k2a(), $completion);
      }
      ifp(project, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, project);
        return this.ufd_1.iff_1.hei('projects/rest/' + tmp$ret$3 + '/accept', HttpMethod_POST_getInstance(), serializer_0(StringCompanionObject_instance), input, Companion_getInstance_38().k2a(), $completion);
      }
      jfp(project, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, project);
        return this.ufd_1.iff_1.hei('projects/rest/' + tmp$ret$3 + '/pay-into-escrow', HttpMethod_POST_getInstance(), Companion_getInstance_57().k2a(), input, get_nullable(Companion_getInstance_39().k2a()), $completion);
      }
      kfp(project, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, project);
        return this.ufd_1.iff_1.hei('projects/rest/' + tmp$ret$3 + '/request-complete', HttpMethod_POST_getInstance(), Companion_getInstance_5().k2a(), input, Companion_getInstance_38().k2a(), $completion);
      }
      lfp(project, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, project);
        return this.ufd_1.iff_1.hei('projects/rest/' + tmp$ret$3 + '/accept-complete', HttpMethod_POST_getInstance(), serializer_0(StringCompanionObject_instance), input, Companion_getInstance_38().k2a(), $completion);
      }
      mfp(project, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, project);
        return this.ufd_1.iff_1.hei('projects/rest/' + tmp$ret$3 + '/request-refunds', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, serializer_1(IntCompanionObject_instance), $completion);
      }
      nfp(project, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, project);
        return this.ufd_1.iff_1.hei('projects/rest/' + tmp$ret$3 + '/request-refunds/check', HttpMethod_POST_getInstance(), Companion_instance_7.k2a(), input, serializer_1(IntCompanionObject_instance), $completion);
      }
      ofp(project, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, project);
        return this.ufd_1.iff_1.hei('projects/rest/' + tmp$ret$3 + '/documents/pay-by-check.html', HttpMethod_POST_getInstance(), Companion_instance.k2a(), new (MonetaryValue())(input), serializer_0(StringCompanionObject_instance), $completion);
      }
      pfp(project, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, project);
        return this.ufd_1.iff_1.hei('projects/rest/' + tmp$ret$3 + '/documents/pay-by-wire.html', HttpMethod_POST_getInstance(), Companion_instance.k2a(), new (MonetaryValue())(input), serializer_0(StringCompanionObject_instance), $completion);
      }
      qfp(project, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, project);
        return this.ufd_1.iff_1.hei('projects/rest/' + tmp$ret$3 + '/pay-into-escrow/external', HttpMethod_POST_getInstance(), Companion_getInstance_40().k2a(), input, serializer(Unit_instance), $completion);
      }
      lfi($completion) {
        return this.ufd_1.iff_1.hei('projects/rest/file-upload-url', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_instance_9.k2a(), $completion);
      }
      rfp(input, $completion) {
        return this.rfd_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.rfp(input, $completion);
      }
      sfp(input, $completion) {
        return this.rfd_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.sfp(input, $completion);
      }
      tfp(input, $completion) {
        return this.rfd_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.tfp(input instanceof Project() ? input : THROW_CCE(), $completion);
      }
      ufp(input, $completion) {
        return this.rfd_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.ufp(input, $completion);
      }
      vfp(id, input, $completion) {
        return this.rfd_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.vfp(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_29.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      wfp(input, $completion) {
        return this.rfd_1.nek(input, $completion);
      }
      xfp(input, $completion) {
        return this.rfd_1.oek(input, $completion);
      }
      dfa(input, $completion) {
        return this.sfd_1.dfa(input, $completion);
      }
      vf9(input, $completion) {
        return this.sfd_1.vf9(input, $completion);
      }
      tek() {
        return this.tfd_1.tek();
      }
    }
    initMetadataForClass($, 'Api2ProjectLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2ProjectLiveClass = $;
  }
  return Api2ProjectLiveClass;
}
var Api2ProjectLedgerItemLiveClass;
function Api2ProjectLedgerItemLive() {
  if (Api2ProjectLedgerItemLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.xfd_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_39().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.vfd_1 = new (ClientModelRestEndpointsLive())(this.xfd_1.iff_1, 'project-ledger-items/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_39().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.wfd_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.xfd_1.iff_1, 'project-ledger-items/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      yfp(input, $completion) {
        return this.vfd_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.yfp(input, $completion);
      }
      zfp(input, $completion) {
        return this.vfd_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.zfp(input, $completion);
      }
      afq(input, $completion) {
        return this.vfd_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.afq(input instanceof ProjectLedgerItem() ? input : THROW_CCE(), $completion);
      }
      bfq(input, $completion) {
        return this.vfd_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.bfq(input, $completion);
      }
      cfq(id, input, $completion) {
        return this.vfd_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.cfq(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_30.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      tek() {
        return this.wfd_1.tek();
      }
    }
    initMetadataForClass($, 'Api2ProjectLedgerItemLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2ProjectLedgerItemLiveClass = $;
  }
  return Api2ProjectLedgerItemLiveClass;
}
var Api2ProjectMessageLiveClass;
function Api2ProjectMessageLive() {
  if (Api2ProjectMessageLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.bfe_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_41().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.yfd_1 = new (ClientModelRestEndpointsLive())(this.bfe_1.iff_1, 'project-messages/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.zfd_1 = new (HasReadByEndpointsLive())(this.bfe_1.iff_1, 'project-messages/rest', Companion_getInstance_41().k2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_41().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.afe_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.bfe_1.iff_1, 'project-messages/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      dfq(input, $completion) {
        return this.yfd_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.dfq(input, $completion);
      }
      efq(input, $completion) {
        return this.yfd_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.efq(input, $completion);
      }
      ffq(input, $completion) {
        return this.yfd_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.ffq(input instanceof ProjectMessage() ? input : THROW_CCE(), $completion);
      }
      gfq(input, $completion) {
        return this.yfd_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.gfq(input, $completion);
      }
      hfq(id, input, $completion) {
        return this.yfd_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.hfq(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_31.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      vf9(input, $completion) {
        return this.zfd_1.vf9(input, $completion);
      }
      tek() {
        return this.afe_1.tek();
      }
    }
    initMetadataForClass($, 'Api2ProjectMessageLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2ProjectMessageLiveClass = $;
  }
  return Api2ProjectMessageLiveClass;
}
var Api2ProjectSettlementDocumentationLiveClass;
function Api2ProjectSettlementDocumentationLive() {
  if (Api2ProjectSettlementDocumentationLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.efe_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_42().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.cfe_1 = new (ClientModelRestEndpointsLive())(this.efe_1.iff_1, 'settlements/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_42().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.dfe_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.efe_1.iff_1, 'settlements/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      lfi($completion) {
        return this.efe_1.iff_1.hei('settlements/rest/file-upload-url', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_instance_9.k2a(), $completion);
      }
      ifq(input, $completion) {
        return this.cfe_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.ifq(input, $completion);
      }
      jfq(input, $completion) {
        return this.cfe_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.jfq(input, $completion);
      }
      kfq(input, $completion) {
        return this.cfe_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.kfq(input instanceof ProjectSettlementDocumentation() ? input : THROW_CCE(), $completion);
      }
      lfq(input, $completion) {
        return this.cfe_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.lfq(input, $completion);
      }
      mfq(id, input, $completion) {
        return this.cfe_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.mfq(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_32.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      tek() {
        return this.dfe_1.tek();
      }
    }
    initMetadataForClass($, 'Api2ProjectSettlementDocumentationLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2ProjectSettlementDocumentationLiveClass = $;
  }
  return Api2ProjectSettlementDocumentationLiveClass;
}
var Api2ProjectTimerLiveClass;
function Api2ProjectTimerLive() {
  if (Api2ProjectTimerLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.hfe_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_43().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.ffe_1 = new (ClientModelRestEndpointsLive())(this.hfe_1.iff_1, 'project-timers/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_43().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.gfe_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.hfe_1.iff_1, 'project-timers/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      nfq($completion) {
        return this.hfe_1.iff_1.hei('project-timers/rest/refresh', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
      }
      ofq(input, $completion) {
        return this.ffe_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.ofq(input, $completion);
      }
      pfq(input, $completion) {
        return this.ffe_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.pfq(input, $completion);
      }
      qfq(input, $completion) {
        return this.ffe_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.qfq(input instanceof ProjectTimer() ? input : THROW_CCE(), $completion);
      }
      rfq(input, $completion) {
        return this.ffe_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.rfq(input, $completion);
      }
      sfq(id, input, $completion) {
        return this.ffe_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.sfq(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_33.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      tek() {
        return this.gfe_1.tek();
      }
    }
    initMetadataForClass($, 'Api2ProjectTimerLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2ProjectTimerLiveClass = $;
  }
  return Api2ProjectTimerLiveClass;
}
var Api2PunchListItemLiveClass;
function Api2PunchListItemLive() {
  if (Api2PunchListItemLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.lfe_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_44().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.ife_1 = new (ClientModelRestEndpointsLive())(this.lfe_1.iff_1, 'punch-lists-items/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.jfe_1 = new (HasReadByEndpointsLive())(this.lfe_1.iff_1, 'punch-lists-items/rest', Companion_getInstance_44().k2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_44().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.kfe_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.lfe_1.iff_1, 'punch-lists-items/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      tfq(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.lfe_1.iff_1.hei('punch-lists-items/rest/' + tmp$ret$3 + '/complete', HttpMethod_PATCH_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_44().k2a(), $completion);
      }
      ufq(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.lfe_1.iff_1.hei('punch-lists-items/rest/' + tmp$ret$3 + '/reset', HttpMethod_PATCH_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_44().k2a(), $completion);
      }
      vfq(input, $completion) {
        return this.ife_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.vfq(input, $completion);
      }
      wfq(input, $completion) {
        return this.ife_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.wfq(input, $completion);
      }
      xfq(input, $completion) {
        return this.ife_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.xfq(input instanceof PunchListItem() ? input : THROW_CCE(), $completion);
      }
      yfq(input, $completion) {
        return this.ife_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.yfq(input, $completion);
      }
      zfq(id, input, $completion) {
        return this.ife_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.zfq(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_34.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      vf9(input, $completion) {
        return this.jfe_1.vf9(input, $completion);
      }
      tek() {
        return this.kfe_1.tek();
      }
    }
    initMetadataForClass($, 'Api2PunchListItemLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2PunchListItemLiveClass = $;
  }
  return Api2PunchListItemLiveClass;
}
var Api2ScopeViewLiveClass;
function Api2ScopeViewLive() {
  if (Api2ScopeViewLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.pfe_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_45().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.mfe_1 = new (ClientModelRestEndpointsLive())(this.pfe_1.iff_1, 'scope-views/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.nfe_1 = new (HasReadByEndpointsLive())(this.pfe_1.iff_1, 'scope-views/rest', Companion_getInstance_45().k2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_45().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.ofe_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.pfe_1.iff_1, 'scope-views/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      afr(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp = 'scope-views/rest/' + this_0.v27(tmp$ret$1, id) + '/update-items';
        var tmp_0 = HttpMethod_POST_getInstance();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$6 = [];
        return this.pfe_1.iff_1.hei(tmp, tmp_0, ListSerializer(ContextualSerializer().zy(tmp_1, null, tmp$ret$6)), input, serializer(Unit_instance), $completion);
      }
      bfr(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp = 'scope-views/rest/' + this_0.v27(tmp$ret$1, id) + '/add-items';
        var tmp_0 = HttpMethod_POST_getInstance();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$6 = [];
        return this.pfe_1.iff_1.hei(tmp, tmp_0, ListSerializer(ContextualSerializer().zy(tmp_1, null, tmp$ret$6)), input, serializer(Unit_instance), $completion);
      }
      cfr(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.pfe_1.iff_1.hei('scope-views/rest/' + tmp$ret$3 + '/request-complete', HttpMethod_POST_getInstance(), Companion_getInstance_31().k2a(), input, serializer(Unit_instance), $completion);
      }
      dfr(input, $completion) {
        return this.mfe_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.dfr(input, $completion);
      }
      efr(input, $completion) {
        return this.mfe_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.efr(input, $completion);
      }
      ffr(input, $completion) {
        return this.mfe_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.ffr(input instanceof ScopeView() ? input : THROW_CCE(), $completion);
      }
      gfr(input, $completion) {
        return this.mfe_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.gfr(input, $completion);
      }
      hfr(id, input, $completion) {
        return this.mfe_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.hfr(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_35.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      vf9(input, $completion) {
        return this.nfe_1.vf9(input, $completion);
      }
      tek() {
        return this.ofe_1.tek();
      }
    }
    initMetadataForClass($, 'Api2ScopeViewLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2ScopeViewLiveClass = $;
  }
  return Api2ScopeViewLiveClass;
}
var Api2SmsProofLiveClass;
function Api2SmsProofLive() {
  if (Api2SmsProofLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.jfr_1 = $outer;
        this.ifr_1 = new (SmsProofClientEndpointsLive())(this.jfr_1.iff_1, 'auth/proof/sms');
      }
      pei(input, $completion) {
        return this.ifr_1.pei(input, $completion);
      }
      qei(input, $completion) {
        return this.ifr_1.qei(input, $completion);
      }
    }
    initMetadataForClass($, 'Api2SmsProofLive', VOID, VOID, VOID, [1]);
    Api2SmsProofLiveClass = $;
  }
  return Api2SmsProofLiveClass;
}
var Api2SpecificationLiveClass;
function Api2SpecificationLive() {
  if (Api2SpecificationLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.sfe_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_46().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.qfe_1 = new (ClientModelRestEndpointsLive())(this.sfe_1.iff_1, 'specifications/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_46().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.rfe_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.sfe_1.iff_1, 'specifications/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      lfi($completion) {
        return this.sfe_1.iff_1.hei('specifications/rest/file-upload-url', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_instance_9.k2a(), $completion);
      }
      kfr(input, $completion) {
        return this.qfe_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.kfr(input, $completion);
      }
      lfr(input, $completion) {
        return this.qfe_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.lfr(input, $completion);
      }
      mfr(input, $completion) {
        return this.qfe_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.mfr(input instanceof Specification() ? input : THROW_CCE(), $completion);
      }
      nfr(input, $completion) {
        return this.qfe_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.nfr(input, $completion);
      }
      ofr(id, input, $completion) {
        return this.qfe_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.ofr(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_36.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      tek() {
        return this.rfe_1.tek();
      }
    }
    initMetadataForClass($, 'Api2SpecificationLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2SpecificationLiveClass = $;
  }
  return Api2SpecificationLiveClass;
}
var Api2TradeLiveClass;
function Api2TradeLive() {
  if (Api2TradeLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.ufe_1 = $outer;
        this.tfe_1 = new (ClientModelRestEndpointsLive())(this.ufe_1.iff_1, 'trades/rest', Companion_instance_8.k2a(), serializer_0(StringCompanionObject_instance));
      }
      pfr(input, $completion) {
        return this.tfe_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.pfr(input, $completion);
      }
      qfr(input, $completion) {
        return this.tfe_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.qfr(input, $completion);
      }
      rfr(input, $completion) {
        return this.tfe_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.rfr(input instanceof Trade() ? input : THROW_CCE(), $completion);
      }
      sfr(input, $completion) {
        return this.tfe_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.sfr(input, $completion);
      }
      tfr(id, input, $completion) {
        return this.tfe_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.tfr(typeof id === 'string' ? id : THROW_CCE(), input, $completion);
      }
      hfk(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_37.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.hfk(typeof id === 'string' ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2TradeLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 0, 1]);
    Api2TradeLiveClass = $;
  }
  return Api2TradeLiveClass;
}
var Api2UnlockProjectRequestLiveClass;
function Api2UnlockProjectRequestLive() {
  if (Api2UnlockProjectRequestLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.xfe_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_47().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.vfe_1 = new (ClientModelRestEndpointsLive())(this.xfe_1.iff_1, 'unlock-project-requests/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_47().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.wfe_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.xfe_1.iff_1, 'unlock-project-requests/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      ufr(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.xfe_1.iff_1.hei('unlock-project-requests/rest/' + tmp$ret$3 + '/accept', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_47().k2a(), $completion);
      }
      vfr(input, $completion) {
        return this.vfe_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.vfr(input, $completion);
      }
      wfr(input, $completion) {
        return this.vfe_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.wfr(input, $completion);
      }
      xfr(input, $completion) {
        return this.vfe_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.xfr(input instanceof UnlockProjectRequest() ? input : THROW_CCE(), $completion);
      }
      yfr(input, $completion) {
        return this.vfe_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.yfr(input, $completion);
      }
      zfr(id, input, $completion) {
        return this.vfe_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.zfr(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_38.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      tek() {
        return this.wfe_1.tek();
      }
    }
    initMetadataForClass($, 'Api2UnlockProjectRequestLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2UnlockProjectRequestLiveClass = $;
  }
  return Api2UnlockProjectRequestLiveClass;
}
var Api2UserLiveClass;
function Api2UserLive() {
  if (Api2UserLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.aff_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_48().k2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.yfe_1 = new (ClientModelRestEndpointsLive())(this.aff_1.iff_1, 'users/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_48().k2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.zfe_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.aff_1.iff_1, 'users/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      afs(input, $completion) {
        return this.aff_1.iff_1.hei('users/rest/verify-phone-number', HttpMethod_PATCH_getInstance(), Companion_getInstance_58().k2a(), input, Companion_getInstance_59().b2j(Companion_getInstance_48().k2a()), $completion);
      }
      bfs(input, $completion) {
        return this.aff_1.iff_1.hei('users/rest/add-to-membership', HttpMethod_PATCH_getInstance(), Companion_getInstance_6().k2a(), input, get_nullable(Companion_getInstance_48().k2a()), $completion);
      }
      cfs(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, id);
        return this.aff_1.iff_1.hei('users/rest/' + tmp$ret$3 + '/remove-from-membership', HttpMethod_PATCH_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_48().k2a(), $completion);
      }
      dfs(input, $completion) {
        return this.yfe_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.dfs(input, $completion);
      }
      efs(input, $completion) {
        return this.yfe_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.efs(input, $completion);
      }
      ffs(input, $completion) {
        return this.yfe_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.ffs(input instanceof User() ? input : THROW_CCE(), $completion);
      }
      gfs(input, $completion) {
        return this.yfe_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.gfs(input, $completion);
      }
      hfs(id, input, $completion) {
        return this.yfe_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.hfs(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_39.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      tek() {
        return this.zfe_1.tek();
      }
    }
    initMetadataForClass($, 'Api2UserLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2UserLiveClass = $;
  }
  return Api2UserLiveClass;
}
var Api2UserAuthLiveClass;
function Api2UserAuthLive() {
  if (Api2UserAuthLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.dff_1 = $outer;
        var tmp = this;
        var tmp_0 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.bff_1 = new (UserAuthClientEndpointsLive())(this.dff_1.iff_1, 'auth/user', ContextualSerializer().zy(tmp_0, null, tmp$ret$2));
        var tmp_1 = this;
        var tmp_2 = Companion_getInstance_48().k2a();
        var tmp_3 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_1.cff_1 = new (AuthenticatedUserAuthClientEndpointsLive())(this.dff_1.iff_1, 'auth/user', tmp_2, ContextualSerializer().zy(tmp_3, null, tmp$ret$5));
      }
      ifs(input, $completion) {
        return this.dff_1.iff_1.hei('auth/user/register-start', HttpMethod_POST_getInstance(), Companion_getInstance_7().k2a(), input, serializer_0(StringCompanionObject_instance), $completion);
      }
      jfs(input, $completion) {
        return this.dff_1.iff_1.hei('auth/user/register', HttpMethod_POST_getInstance(), Companion_instance_5.k2a(), input, Companion_getInstance_48().k2a(), $completion);
      }
      kfs($completion) {
        return this.dff_1.iff_1.hei('auth/user/payments/payment-setup', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, serializer_0(StringCompanionObject_instance), $completion);
      }
      lfs($completion) {
        return this.dff_1.iff_1.hei('auth/user/payments/payment-publishable-key', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, serializer_0(StringCompanionObject_instance), $completion);
      }
      mfs($completion) {
        return this.dff_1.iff_1.hei('auth/user/payments', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, ListSerializer(Companion_instance_10.k2a()), $completion);
      }
      nfs(methodId, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, methodId);
        return this.dff_1.iff_1.hei('auth/user/payments/' + tmp$ret$3, HttpMethod_PATCH_getInstance(), serializer_0(StringCompanionObject_instance), input, Companion_instance_10.k2a(), $completion);
      }
      ofs(methodId, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.v27(tmp$ret$1, methodId);
        return this.dff_1.iff_1.hei('auth/user/payments/' + tmp$ret$3, HttpMethod_DELETE_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
      }
      pfs(input, $completion) {
        return this.dff_1.iff_1.hei('auth/user/payments/setup-direct-payment-info', HttpMethod_POST_getInstance(), Companion_instance_0.k2a(), input, Companion_getInstance_0().k2a(), $completion);
      }
      qfs(input, $completion) {
        return this.dff_1.iff_1.hei('auth/user/payments/verify-direct-payment-info', HttpMethod_POST_getInstance(), Companion_getInstance_1().k2a(), input, Companion_getInstance_0().k2a(), $completion);
      }
      rfs($completion) {
        return this.dff_1.iff_1.hei('auth/user/payments/clear-direct-payment-info', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
      }
      sfs($completion) {
        return this.dff_1.iff_1.hei('auth/user/payments/clear-payment-info', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
      }
      tfs($completion) {
        return this.dff_1.iff_1.hei('auth/user/payments/direct-payment-info', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, get_nullable(Companion_getInstance_0().k2a()), $completion);
      }
      uei(input, $completion) {
        return this.bff_1.uei(input, $completion);
      }
      vei(input, $completion) {
        return this.bff_1.vei(input, $completion);
      }
      aej($completion) {
        return this.cff_1.aej($completion);
      }
      bej($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_terminateSession__vfalvx.bind(VOID, this), $completion);
      }
    }
    initMetadataForClass($, 'Api2UserAuthLive', VOID, VOID, VOID, [1, 0, 2]);
    Api2UserAuthLiveClass = $;
  }
  return Api2UserAuthLiveClass;
}
var Api2UserSessionLiveClass;
function Api2UserSessionLive() {
  if (Api2UserSessionLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.fff_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_60();
        var tmp_1 = Companion_getInstance_48().k2a();
        var tmp_2 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        var tmp_3 = tmp_0.x2y(tmp_1, ContextualSerializer().zy(tmp_2, null, tmp$ret$2));
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp.eff_1 = new (ClientModelRestEndpointsLive())(this.fff_1.iff_1, 'auth/user/sessions', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      ufs(input, $completion) {
        return this.eff_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.ufs(input, $completion);
      }
      vfs(input, $completion) {
        return this.eff_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.vfs(input, $completion);
      }
      wfs(input, $completion) {
        return this.eff_1.eek(input, $completion);
      }
      eek(input, $completion) {
        return this.wfs(input instanceof Session() ? input : THROW_CCE(), $completion);
      }
      xfs(input, $completion) {
        return this.eff_1.fek(input, $completion);
      }
      fek(input, $completion) {
        return this.xfs(input, $completion);
      }
      yfs(id, input, $completion) {
        return this.eff_1.gek(id, input, $completion);
      }
      gek(id, input, $completion) {
        return this.yfs(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      zfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_40.bind(VOID, this, id), $completion);
      }
      hek(id, $completion) {
        return this.zfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2UserSessionLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 0, 1]);
    Api2UserSessionLiveClass = $;
  }
  return Api2UserSessionLiveClass;
}
var LiveApi2Class;
function LiveApi2() {
  if (LiveApi2Class === VOID) {
    class $ {
      constructor(fetcher) {
        this.iff_1 = fetcher;
        this.jff_1 = new (Api2AdminReportsLive())(this);
        this.kff_1 = new (Api2ApprovedStateLive())(this);
        this.lff_1 = new (Api2ChangeRequestLive())(this);
        this.mff_1 = new (Api2ClientLive())(this);
        this.nff_1 = new (Api2CompletionMessageCommentLive())(this);
        this.off_1 = new (Api2ContractorLive())(this);
        this.pff_1 = new (Api2ContractorDocumentLive())(this);
        this.qff_1 = new (Api2ContractorNoteLive())(this);
        this.rff_1 = new (Api2CrowPayLegalDocumentLive())(this);
        this.sff_1 = new (Api2DebugLive())(this);
        this.tff_1 = new (Api2DisputeLive())(this);
        this.uff_1 = new (Api2EmailProofLive())(this);
        this.vff_1 = new (Api2EntityTypeLive())(this);
        this.wff_1 = new (Api2EventSubscriptionLive())(this);
        this.xff_1 = new (Api2FundsRequestLive())(this);
        this.yff_1 = new (Api2FunnelInstanceLive())(this);
        this.zff_1 = new (Api2FunnelSummaryLive())(this);
        this.afg_1 = new (Api2IncidentLive())(this);
        this.bfg_1 = new (Api2IncidentMessageLive())(this);
        this.cfg_1 = new (Api2IncidentMessageCommentLive())(this);
        this.dfg_1 = new (Api2ItemChangeLive())(this);
        this.efg_1 = new (Api2LegalDocumentAgreementLive())(this);
        this.ffg_1 = new (Api2LicenseLive())(this);
        this.gfg_1 = new (Api2LineItemLive())(this);
        this.hfg_1 = new (Api2LineItemCompletionMessageLive())(this);
        this.ifg_1 = new (Api2MailCheckPhysicallyLive())(this);
        this.jfg_1 = new (Api2NotificationLive())(this);
        this.kfg_1 = new (Api2OneTimePasswordProofLive())(this);
        this.lfg_1 = new (Api2OtpSecretLive())(this);
        this.mfg_1 = new (Api2PayAppItemLive())(this);
        this.nfg_1 = new (Api2PayApplicationLive())(this);
        this.ofg_1 = new (Api2PayoutLive())(this);
        this.pfg_1 = new (Api2PendingItemChangeLive())(this);
        this.qfg_1 = new (Api2PendingLineItemLive())(this);
        this.rfg_1 = new (Api2ProjectLive())(this);
        this.sfg_1 = new (Api2ProjectLedgerItemLive())(this);
        this.tfg_1 = new (Api2ProjectMessageLive())(this);
        this.ufg_1 = new (Api2ProjectSettlementDocumentationLive())(this);
        this.vfg_1 = new (Api2ProjectTimerLive())(this);
        this.wfg_1 = new (Api2PunchListItemLive())(this);
        this.xfg_1 = new (Api2ScopeViewLive())(this);
        this.yfg_1 = new (Api2SmsProofLive())(this);
        this.zfg_1 = new (Api2SpecificationLive())(this);
        this.afh_1 = new (Api2TradeLive())(this);
        this.bfh_1 = new (Api2UnlockProjectRequestLive())(this);
        this.cfh_1 = new (Api2UserLive())(this);
        this.dfh_1 = new (Api2UserAuthLive())(this);
        this.efh_1 = new (Api2UserSessionLive())(this);
      }
      teq(headerCalculator) {
        return new (LiveApi2())(this.iff_1.teq(headerCalculator));
      }
    }
    initMetadataForClass($, 'LiveApi2', VOID, VOID, VOID, [1, 0]);
    LiveApi2Class = $;
  }
  return LiveApi2Class;
}
//region block: exports
export {
  LiveApi2 as LiveApi22p7ep9cwyglni,
};
//endregion

//# sourceMappingURL=LiveApi.mjs.map
